module.exports = "https://cdn.ticketswap.com/_next/static/images/festivals-a7d4ecf0ae66fcd3a8fdce545e9f44b2.jpg";